import { createStore } from 'vuex'
import ApiSite from '@/classes/ApiSite'
import forEach from 'dcode/functions/forEach'
import getNavigation from '@/functions/getNavigation'
import getPopular from '@/functions/getPopular'
import getRecommend from '@/functions/getRecommend'
import getPostLink from '@/functions/getPostLink'
import getElements from '@/functions/getElements'
import getNotFound from '@/functions/getNotFound'
import getAllList from '@/functions/getAllList'
import getSlugMap from '@/functions/getSlugMap'

export default createStore({
  state () {
    return {
      banner: false,
      /**
       * @type {Object.<string, string|boolean|Array|Object>}
       */
      basic: undefined,
      loading: 0,
      navigationStatus: false,
      notFound: false,
      notFoundNone: false,
      /**
       * @type {Object.<string, string|boolean|Array|Object>}
       */
      post: undefined,
      pointer: []
    }
  },
  getters: {
    isBanner (state) {
      return state.post?.banner || state.banner
    },
    isBasic (state) {
      return state.basic !== undefined
    },
    get404 (state) {
      return state.basic?.[404]
    },
    getBreadcrumbs (state) {
      if (
        state.post &&
        'breadcrumbs' in state.post
      ) {
        return state.post.breadcrumbs
      } else if (
        state.post &&
        'value' in state.post &&
        'navigation' in state.basic &&
        state.basic.navigation
      ) {
        const breadcrumbs = []

        forEach(state.basic.navigation, section => {
          if (section.value === state.post.value) {
            breadcrumbs.push({
              text: section.text,
              value: getPostLink(section),
              isCategory: section.isCategory || false
            })
          } else if ('list' in section) {
            const item = section.list.find(item => item.value === state.post.value)

            if (item) {
              breadcrumbs.push({
                text: section.text,
                value: getPostLink(section),
                isCategory: section.isCategory || false
              })

              breadcrumbs.push({
                text: item.text,
                value: getPostLink(item),
                isCategory: false
              })
            }
          }
        })

        return breadcrumbs
      } else {
        return []
      }
    },
    getCountries (state) {
      return state.basic?.countries
    },
    getElements (state) {
      return state.basic?.elements || []
    },
    getLoading (state) {
      return state.loading > 0
    },
    getName (state) {
      return state.post?.text
    },
    getNavigation (state) {
      return state.basic?.navigation || []
    },
    getNavigationStatus (state) {
      return state.navigationStatus
    },
    getNotFound (state) {
      return state.post?.notFound || state.notFound || state.notFoundNone
    },
    getPointer (state) {
      return state.pointer || []
    },
    getPopular (state) {
      return state.basic?.popular
    },
    getPost (state) {
      return state.post?.post || ''
    },
    getPostIds (state) {
      return state.basic?.allList || []
    },
    getRecommend (state) {
      return state.basic?.recommend
    },
    getSection (state) {
      return state.post?.section || []
    },
    getValue (state) {
      return (state.post?.value || 0).toString()
    },
    getSlugToValue (state) {
      return state.basic?.slugToValue || {}
    },
    getValueToSlug (state) {
      return state.basic?.valueToSlug || {}
    }
  },
  mutations: {
    loadingShow (state) {
      state.loading++
    },
    loadingHide (state) {
      state.loading--
    },
    setBanner (state, value) {
      state.banner = value
    },
    setNavigationStatus (state, value = undefined) {
      state.navigationStatus = value === undefined ? !state.navigationStatus : value
    },
    setNotFound (state, value) {
      state.notFound = value
    },
    setNotFoundNone (state, value) {
      state.notFoundNone = value
    },
    setPost (state, post) {
      state.post = post
    },
    addPointer (state, {
      index,
      name
    }) {
      state.pointer.push({
        index,
        name
      })
    },
    resetPointer (state) {
      state.pointer = []
    }
  },
  actions: {
    async init ({
      commit,
      state
    }) {
      try {
        commit('loadingShow')

        const basic = await ApiSite.init()

        const slugMapping = getSlugMap(basic)

        state.basic = {
          allList: getAllList(basic),
          elements: getElements(basic),
          navigation: getNavigation(basic),
          popular: getPopular(basic?.main),
          recommend: getRecommend(basic?.main),
          404: getNotFound(basic?.[404]),
          slugToValue: slugMapping.slugToValue,
          valueToSlug: slugMapping.valueToSlug
        }

        if ('none' in basic) {
          commit('setNotFoundNone', true)
        }

        commit('loadingHide')
      } catch (e) {
        state.post = { notFound: true }
      }
    },
    async setPost (
      {
        commit,
        state
      },
      item,
      mobile
    ) {
      commit('resetPointer')
      commit('setBanner', false)
      commit('setPost', { value: state.post?.value })
      commit('setNotFound', false)
      commit('setNavigationStatus', false)

      if (typeof item === 'string') {
        commit('loadingShow')

        try {
          const post = await ApiSite.getPost(item, mobile)
          commit('setPost', {
            ...post,
            notFound: post.post === '' || !post.post
          })
        } catch (e) {
          commit('setPost', { notFound: true })
        }

        commit('loadingHide')
      } else {
        commit('setPost', item)
      }
    }
  },
  modules: {}
})
